import { ModalsKey } from '@/enums/modalsKey';
import { RootState } from '@/lib/store';
import { Button, StaggerAnimation } from '@starsoft/common/components';
import { useModal, useTranslation } from '@starsoft/common/hooks';
import { AnimatePresence } from 'framer-motion';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import RestrictionDetailsModalDescription from './Description';
import RestrictionDetailsModalLottie from './Lottie';
import RestrictionDetailsModalRenderer from './Renderer';
import styles from './styles.module.scss';

export default function RestrictionDetailsModalContent() {
  const { t } = useTranslation('common');
  const { onClose } = useModal(ModalsKey.UserRestrictionsDetails);
  const { push } = useRouter();
  const isAdminView = useSelector(
    (state: RootState) => state.theme.isAdminEmbed,
  );

  function handleCloseModal() {
    onClose();
  }

  function handleManageRestrictions() {
    if (isAdminView) {
      return;
    }

    push('/account/restrictions');
  }

  return (
    <div className={styles.container}>
      <div className={styles.container__content}>
        <RestrictionDetailsModalLottie />
        <RestrictionDetailsModalDescription />
        <AnimatePresence presenceAffectsLayout>
          <StaggerAnimation
            direction="column"
            stagger={0.1}
            staggerDirection="down"
            className={styles.container__content}
          >
            <RestrictionDetailsModalRenderer />
          </StaggerAnimation>
        </AnimatePresence>
      </div>
      <div className={styles.container__content__wrapper}>
        <Button isSecondary onClick={handleCloseModal}>
          {t('close_label')}
        </Button>
        <Button onClick={handleManageRestrictions}>
          {t('manage_restrictions')}
        </Button>
      </div>
    </div>
  );
}
